export class ProfileDataObj {
    'name': string;
    'email': string;
    'mobile': any;
    'company': string;
    'dob': any;
}